import { Col, Row } from 'antd';
import breakpoints from 'constants/breakpoints';
import styled from 'styled-components';

export const FlexColStyled = styled(Col)`
  margin-left: 16px;
  margin-right: 16px;
`;

export const SectionHeaderContainerStyled = styled(Row)`
  margin-bottom: 5px;
`;

export const SectionTitleContainerStyled = styled(Col)<{ $hasMarginTop?: boolean }>`
  padding: 10px;
  border-bottom: 1px solid #dedede;
  margin-bottom: 10px !important;
  margin-top: ${({ $hasMarginTop }) => ($hasMarginTop ? '20px !important' : 'initial')};
  font-weight: 500;
  font-size: 16px;
`;

export const LabelsContainerStyled = styled(Row)`
  @media screen and (max-width: ${breakpoints.lg}) {
    display: none;
  }
`;

export const ClearButtonIconContainerStyled = styled(Row)`
  height: 36px;
  padding: 0 15px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  border: 1px solid transparent;
  &:hover {
    color: red;
  }
  border-radius: 4px;
`;

export const MainAndSideInputsContainer = styled(Row)`
  @media screen and (max-width: ${breakpoints.lg}) {
  }
`;

export const ErrorRequiredStyled = styled.div`
  color: red;
  margin-bottom: 10px;
`;
